import { Injectable } from '@angular/core';
import { DbBaseProviderService } from './db-base-provider.service';
import { RxdbInitializerService } from './rxdb-initializer.service';
import { ISaveApplicationInput, ISaveSubmitApplicationInput, ISubmitApplicationInput } from '../model/application-service.model';
import { MangoQuery } from 'rxdb';

@Injectable({
    providedIn: 'root'
})
export class OfflineApplicationDbProviderService extends DbBaseProviderService {
    constructor(rxdbInitializerService: RxdbInitializerService) {
        super();
        this.currentCollection = rxdbInitializerService.getOfflineApplicationCollection();
    }

    public async addOfflineApplication(
        dto: ISubmitApplicationInput | ISaveApplicationInput,
        submitFlag: boolean = false
    ) {
        (<any>dto).eventType = !submitFlag ? 'save' : 'submit';
        // cloning should help to avoid "TypeError: Cannot add property" exception
        await (await this.currentCollection)?.incrementalUpsert(JSON.parse(JSON.stringify(dto)));
    }

    public async findOfflineApplicationById(applicationId: string): Promise<ISubmitApplicationInput | ISaveApplicationInput | null> {
        return await this.findFirstItem<ISubmitApplicationInput | ISaveApplicationInput | null>(
            this.findByIds.bind(this, this.currentCollection, [applicationId]));
    }

    public async getSavedApplications(): Promise<ISaveApplicationInput[]> {
        var filter: MangoQuery<ISaveApplicationInput> = {
            selector: {
                $and: [{ eventType: 'save' }]
            }
        };
        return await this.findItems(this.currentCollection, filter);
    }

    public async getSubmittedApplications(): Promise<ISubmitApplicationInput[]> {
        var filter: MangoQuery<ISubmitApplicationInput> = {
            selector: {
                $and: [{ eventType: 'submit' }]
            }
        };
        return await this.findItems(this.currentCollection, filter);
    }

    public async getAllOfflineApplications(): Promise<(ISubmitApplicationInput | ISaveApplicationInput)[]> {
        return await this.findItems(this.currentCollection, {});
    }

    public async getListOfSubmittedApplicationByFormId(formId): Promise<(ISubmitApplicationInput | ISaveApplicationInput)[]> {
        var filter: MangoQuery<any> = {
            selector: {
                $and: [ { formId: formId } ]
            }
        };
        return await this.findItems(this.currentCollection, filter);
    }

    public async removeItem(offlineAppId: string): Promise<ISubmitApplicationInput[]> {
        var filter: MangoQuery<any> = {
            selector: {
                $and: [ { offlineApplicationId: offlineAppId } ]
            }
        };
        return await this.remove(this.currentCollection, filter);
    }
}
